import React from 'react';

import {CreateSchemaContextProvider} from './context/CreateSchemaContext';
import UploadOntologiesStep from './UploadOntologiesStep';
import GenerateSchemaStep from './GenerateSchemaStep';
import SaveSchemaStep from './SaveSchemaStep';
import ActivateSchemaStep from "./ActivateSchemaStep";
import CompleteCreateSchemaStep from "./CompleteCreateSchemaStep";
import {Wizard, WizardStep} from '../../wizard/Wizard';
import {WorkbenchStateContext} from "../../context/WorkbenchContext";

import './CreateSchemaWizard.scss';

/**
 * Integrates the Wizard component. This component also plays role of a wizard state
 * context provider. All step implementations can use the state from {@link CreateSchemaContext} by
 * declaring the contextType like this
 * <code>UploadOntologiesStep.contextType = CreateSchemaContext;</code>
 * then the context can be accessed through a <code>this.context</code> call.
 */
class CreateSchemaWizard extends React.Component {

  static contextType = WorkbenchStateContext;

  wizardSteps: Array<WizardStep> = [
    {name: 'Upload Ontologies', component: UploadOntologiesStep, descr: ''},
    {name: 'Generate Schema', component: GenerateSchemaStep, descr: ''},
    {name: 'Save Schema', component: SaveSchemaStep, descr: ''},
    {name: 'Activate Schema', component: ActivateSchemaStep, descr: ''},
    {name: 'Done', component: CompleteCreateSchemaStep, descr: ''}
  ];

  render() {
    return (
      <CreateSchemaContextProvider configurations={this.context.configurations}>
        <Wizard steps={this.wizardSteps} className="CreateSchemaWizard"/>
      </CreateSchemaContextProvider>
    )
  }
}

export function CreateSchemaWizardLeavingConfirmationMessage() {
  return <p>Are you sure you want to leave this page? The Create
    Schema Wizard progress will be lost!</p>
}

export default CreateSchemaWizard;
